<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'Sidebar',

    computed: {
      ...mapGetters(['getSelectedHospital', 'getLabel', 'isStepCompleted', 'getExamData', 'getPatientData', 'getSsnData']),

      stepAgreementTitle: function () {
        return this.getLabel('ospedali.form.privacyagreement.title')
      },

      stepAgreementText: function () {
        return this.isStepCompleted(1) ? this.getLabel('ospedali.form.privacyagreement.accepted') : this.getLabel('ospedali.form.privacyagreement.pending')
      },

      stepTreatmentTitle: function () {
        return this.isStepCompleted(2) ? this.getExamData.exam : this.getLabel('ospedali.form.treatment.sidebar')
      },

      stepTreatmentText: function () {
        return this.isStepCompleted(2) ? this.getLabel('ospedali.form.treatment.chosen') : this.getLabel('ospedali.form.treatment.pending')
      },

      stepAppointmentTitle: function () {
        return this.isStepCompleted(3) ? this.getPatientData.patientName + " " + this.getPatientData.patientSurname : this.getLabel('ospedali.form.appointment.groupfield.patient.title')
      },

      stepSsnTitle: function () {
        return this.isStepCompleted(4) ? this.getSsnData.ssnCode : this.getLabel('ospedali.form.ssndetails.sidebar')
      },
      
      submitDisabled: function () {
        let lastStepContion = this.$config.enableSSN ? !this.isStepCompleted(4) : !this.isStepCompleted(3);
         return lastStepContion || !this.enableSubmitButton;
      }
    },

    methods: {
      ...mapActions(['setRegistration']),

      submit: function () {
        this.$analytics.pushEvent("form:submitted");
        this.enableSubmitButton && this.setRegistration(this);
        this.enableSubmitButton = false;
      }
    },

    data: function () {
      return {
        enableSubmitButton: true
      }
    }
  }
</script>

<template>
  <div class="col-md-4">
    <div class="sidebar first-step" v-if="!getSelectedHospital">
      <h4>
        <Msg id="ospedali.form.sidebar.first.title"/>
      </h4>
      <p>
        <Msg id="ospedali.form.sidebar.first.descr"/>
      </p>
      <small>
        <Msg id="ospedali.form.sidebar.first.disclaimer"/>
      </small>
    </div>

    <div class="sidebar" v-else="">
      <h3>
        <Msg id="ospedali.form.sidebar.summary.title"/>
      </h3>
      <ul>
        <li class="hospital-selector">
          <h6>{{ getSelectedHospital.title }}</h6>
          <p>{{ getSelectedHospital.fullAddress }}</p>
          <p>{{ getSelectedHospital.cityAndProvince }}</p>
        </li>
        <li class="privacy-agreement" :class="{uncompleted : !isStepCompleted(1)}">
          <h6>{{stepAgreementTitle}}</h6>
          <p>{{stepAgreementText}}</p>
        </li>
        <li class="treatment-selector" :class="{uncompleted : !isStepCompleted(2)}">
          <h6>{{stepTreatmentTitle}}</h6>
          <p>{{stepTreatmentText}}</p>
        </li>
        <li class="appointment" :class="{uncompleted : !isStepCompleted(3)}">
          <h6>{{ stepAppointmentTitle }}</h6>
          <div v-if="isStepCompleted(3)">
            <p>{{getPatientData.patientBirthPlace}} {{getPatientData.patientBirthDate}}</p>
            <p>{{ getPatientData.patientGender}} </p>
            <p>{{ getPatientData.patientFcode }}</p>
            <p>{{ getPatientData.applicantEmail}}</p>

          </div>
          <p v-if="!isStepCompleted(3)">
            <Msg id="ospedali.form.sidebar.tobecompleted"/>
          </p>
        </li>
        <li class="ssn-details" :class="{uncompleted : !isStepCompleted(4)}" v-if="$config.enableSSN">
          <h6>{{ stepSsnTitle }}</h6>
          <div v-if="isStepCompleted(4)">
            <p>{{getLabel("ospedali.form.sidebar.priority")}} {{ getSsnData.ssnPriority}} </p>
            <p>{{ getSsnData.ssnDate}}</p>
          </div>
          <p v-if="!isStepCompleted(4)">
            <Msg id="ospedali.form.sidebar.tobecompleted"/>
          </p>
        </li>
      </ul>
      <button @click="submit()" class="button-primary" :disabled="submitDisabled">
        {{getLabel('ospedali.form.button.complete')}}
      </button>
    </div>
  </div>
</template>